import {
  ITariffServiceArea,
  TARIFF_SERVICE_AREA,
} from './product-group.interfaces';
import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type OriginReferenceId = Brand<string, 'originReferenceId'>;
export type DestinationReferenceId = Brand<string, 'destinationReferenceId'>;
export type ViaName = Brand<string, 'viaName'>;

export interface IHusstRelationLocation {
  name: string;
  nummer: string;
  extReferenz: string;
  viaSucheMoeglich: boolean;
  drucktext: string | null;
  gemeinde: string | null;
  ort_ID: string | null;
}

export const HUSST_RELATION_LOCATION: z.ZodType<IHusstRelationLocation> =
  z.object({
    name: z.string(),
    nummer: z.string(),
    extReferenz: z.string(),
    viaSucheMoeglich: z.boolean(),
    drucktext: z.string().nullable().default(null),
    gemeinde: z.string().nullable().default(null),
    ort_ID: z.string().nullable().default(null),
  });

export const HUSST_RELATION_LOCATIONS: z.ZodType<IHusstRelationLocation[]> =
  z.array(HUSST_RELATION_LOCATION);

export interface ITariffRelationLocation {
  name: string;
  number: string;
  externalReference: string;
  viaSearchPossible: boolean;
}

export interface IHusstViaTravelPoint {
  idStart: number;
  idZiel: number;
  bahnhofstatusStart: string;
  bahnhofstatusZiel: string;
  wegstreckeInMetern: number;
  wegetext: string | null;
}

export interface IHusstVia {
  verlauf: IHusstViaTravelPoint[];
  ausschlussstrecke: boolean;
  extReferenz: string;
  via: ViaName;
  viaDrucktext: string;
  weitereViasTarifgebiete: ITariffServiceArea[];
  hasWeitereTarifgebiete: boolean;
  start: IHusstRelationLocation;
  ziel: IHusstRelationLocation;
}

export const HUSST_VIA_TRAVEL_POINT: z.ZodType<IHusstViaTravelPoint> = z.object(
  {
    idStart: z.number(),
    idZiel: z.number(),
    bahnhofstatusStart: z.string(),
    bahnhofstatusZiel: z.string(),
    wegstreckeInMetern: z.number(),
    wegetext: z.string().nullable().default(null),
  }
);

export const HUSST_VIA: z.ZodType<IHusstVia> = z.object({
  verlauf: z.array(HUSST_VIA_TRAVEL_POINT),
  ausschlussstrecke: z.boolean(),
  extReferenz: z.string(),
  via: z
    .string()
    .transform(s => s as ViaName)
    .default('' as ViaName),
  viaDrucktext: z.string(),
  weitereViasTarifgebiete: z.array(TARIFF_SERVICE_AREA),
  hasWeitereTarifgebiete: z.boolean(),
  start: HUSST_RELATION_LOCATION,
  ziel: HUSST_RELATION_LOCATION,
});

export const HUSST_VIAS: z.ZodType<IHusstVia[]> = z.array(HUSST_VIA);

export interface ITariffViaTravelPoint {
  originId: number;
  destinationId: number;
  startStationStatus: string;
  endStationStatus: string;
  travelDistance: number;
  travelText: string | null;
}

export interface ITariffRelationVia {
  externalReference: string;
  travelPoints: ITariffViaTravelPoint[];
  via: ViaName;
  additionalServiceAreas: ITariffServiceArea[];
  origin: ITariffRelationLocation;
  destination: ITariffRelationLocation;
}
